import { getExamId } from '@/utils'

/**
 * 判断是否已经完成双机位检测
 * @param {string?} examIdOut 考试id
 * @returns {boolean} 是否已经完成双机位检测
 */
export function isDoubleCameraDetectFinished(examIdOut) {
  let key = 'doubleCameraDetectFinished'

  const examId = examIdOut || getExamId()
  if (examId) {
    key += examId
  }

  return !!localStorage.getItem(key)
}

/**
 * 参数不传或传true时，设置已经完成双机位检测
 * 传false时，设置未完成双机位检测
 * @param {boolean?} isFinished 是否已经完成双机位检测
 * @param {string?} examIdOut 考试id
 */
export function setDoubleCameraDetectFinished(isFinished, examIdOut) {
  let key = 'doubleCameraDetectFinished'

  const examId = examIdOut || getExamId()
  if (examId) {
    key += examId
  }

  if (isFinished === undefined || isFinished) {
    localStorage.setItem(key, 'true')
  } else {
    localStorage.removeItem(key)
  }
}
